import { render, staticRenderFns } from "./SubscribeForm2026.vue?vue&type=template&id=a071d66c&scoped=true&"
import script from "./SubscribeForm2026.vue?vue&type=script&lang=js&"
export * from "./SubscribeForm2026.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeForm2026.vue?vue&type=style&index=0&id=a071d66c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a071d66c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribePlanSwitcher: require('/opt/render/project/src/channels2022/src/components/subscribe2026/SubscribePlanSwitcher.vue').default,SubscribeForm2026PlanHeader: require('/opt/render/project/src/channels2022/src/components/subscribe2026/SubscribeForm2026PlanHeader.vue').default,SubscribePrice: require('/opt/render/project/src/channels2022/src/components/subscribe/price/SubscribePrice.vue').default})
